import { render, staticRenderFns } from "./cahierLocal.vue?vue&type=template&id=6f3f2136&"
import script from "./cahierLocal.vue?vue&type=script&lang=js&"
export * from "./cahierLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports